import * as React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/GlobalStyles": GlobalStyles } } });
export default ClientProvider;
